import { Config } from "../../node_modules/@cvx/cal"

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "cd746967-9236-4fea-bd88-1bf212be654c",
  redirectUri: "https://pcm-dev.azure.chevron.com/",    
  oidcScopes: ["openid", "profile", "email","User.Read","offline_access"],
  graphScopes: ["User.Read", "User.Read.All"]
}
 
export const environment = {
  calConfig: calConfig,
  production: false,
  sendEmail: true,
  //apiUrl: 'http://localhost:44200',
  apiUrl: "https://pcm-api-dev.azure.chevron.com",
  groupName: 'Law%2520-%2520Function%22',
  webUrl: "https://lawaccess-dev.azure.chevron.com",
  msGraphUrl: "https://graph.microsoft.com/v1.0/",
  scopes: ['https://pcm-test.azure.chevron.com/user_impersonation'],
  //apiEndpoint: "https://localhost:7035/api",
  apiEndpoint: "https://lawacctest-api.azurewebsites.net/api",
  ServiceNowURL: "https://chevrontest.service-now.com/now/nav/ui/classic/params/target/sc_req_item.do%3Fsys_id%3D"
};
